function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5779 1.13144H1.33792V10.3714H10.5779V1.13144ZM9.45792 9.25144H2.45792V2.25144H9.45792V9.25144Z",
  fill: "#BFC5D2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.837921 0.631439H11.0779V10.8714H0.837921V0.631439ZM1.83792 1.63144V9.87144H10.0779V1.63144H1.83792ZM1.95792 1.75144H9.95792V9.75144H1.95792V1.75144ZM2.95792 2.75144V8.75144H8.95792V2.75144H2.95792Z",
  fill: "#BFC5D2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8179 10.3714H22.0579V1.13144H12.8179V10.3714ZM13.9379 2.25144H20.9379V9.25144H13.9379V2.25144Z",
  fill: "#BFC5D2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.3179 0.631439H22.5579V10.8714H12.3179V0.631439ZM13.3179 1.63144V9.87144H21.5579V1.63144H13.3179ZM13.4379 1.75144H21.4379V9.75144H13.4379V1.75144ZM14.4379 2.75144V8.75144H20.4379V2.75144H14.4379Z",
  fill: "#BFC5D2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5779 12.6114H1.33792V21.8514H10.5779V12.6114ZM9.45792 20.7314H2.45792V13.7314H9.45792V20.7314Z",
  fill: "#BFC5D2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.837921 12.1114H11.0779V22.3514H0.837921V12.1114ZM1.83792 13.1114V21.3514H10.0779V13.1114H1.83792ZM1.95792 13.2314H9.95792V21.2314H1.95792V13.2314ZM2.95792 14.2314V20.2314H8.95792V14.2314H2.95792Z",
  fill: "#BFC5D2"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4379 12.6114C14.8899 12.6114 12.8179 14.6834 12.8179 17.2314C12.8179 19.7794 14.8899 21.8514 17.4379 21.8514C19.9859 21.8514 22.0579 19.7794 22.0579 17.2314C22.0579 14.6834 19.9859 12.6114 17.4379 12.6114ZM17.4379 20.7314C15.5059 20.7314 13.9379 19.1634 13.9379 17.2314C13.9379 15.2994 15.5059 13.7314 17.4379 13.7314C19.3699 13.7314 20.9379 15.2994 20.9379 17.2314C20.9379 19.1634 19.3699 20.7314 17.4379 20.7314Z",
  fill: "#BFC5D2"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.3179 17.2314C12.3179 14.4073 14.6138 12.1114 17.4379 12.1114C20.2621 12.1114 22.5579 14.4073 22.5579 17.2314C22.5579 20.0556 20.2621 22.3514 17.4379 22.3514C14.6138 22.3514 12.3179 20.0556 12.3179 17.2314ZM17.4379 13.1114C15.1661 13.1114 13.3179 14.9596 13.3179 17.2314C13.3179 19.5033 15.1661 21.3514 17.4379 21.3514C19.7098 21.3514 21.5579 19.5033 21.5579 17.2314C21.5579 14.9596 19.7098 13.1114 17.4379 13.1114ZM17.4379 14.2314C15.7821 14.2314 14.4379 15.5756 14.4379 17.2314C14.4379 18.8873 15.7821 20.2314 17.4379 20.2314C19.0938 20.2314 20.4379 18.8873 20.4379 17.2314C20.4379 15.5756 19.0938 14.2314 17.4379 14.2314ZM13.4379 17.2314C13.4379 15.0233 15.2298 13.2314 17.4379 13.2314C19.6461 13.2314 21.4379 15.0233 21.4379 17.2314C21.4379 19.4396 19.6461 21.2314 17.4379 21.2314C15.2298 21.2314 13.4379 19.4396 13.4379 17.2314Z",
  fill: "#BFC5D2"
});

function SvgProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.ec63628b.svg";
export { ForwardRef as ReactComponent };